// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_dh-6";
export var emphasizeQuantity = "_dh-3";
export var flatBottomCorners = "_dh-5";
export var productImage = "_dh-0";
export var quantityContainer = "_dh-2";
export var tooltip = "_dh-1";
export var wrapAndEllipsesOverflow = "_dh-4";